import React, { useEffect, useState } from "react";
import green_tick from "../../assets/images/green_tick.png";

export default function CG_FooterButtons({ setCurrentScreen, currentScreen, navigate, screen }) {
    const [isMobile, setIsMobile] = useState(false);
    const onNext = () => {
        if (currentScreen < 3) {
            setCurrentScreen(currentScreen + 1);
        } else {
            navigate("/contract-generation/preview-contract/");
        }
    };
    const onPrev = () => {
        if (currentScreen > 0) {
            setCurrentScreen(currentScreen - 1);
        }
    };
    useEffect(() => {
        if (window.innerWidth < 767) {
            setIsMobile(true);
        }
    }, []);
    return (
        <div
            style={{
                width: isMobile ? "calc(100vw)" : "100%",
            }}
            className="tw-bg-[#F0F0F0] tw-px-2 xl:tw-px-5 tw-py-2 tw-sticky tw-bottom-0 tw-right-0  tw-flex tw-items-center tw-justify-between"
        >
            <div className="tw-flex tw-items-center tw-gap-2">
                <img src={green_tick} className=" tw-h-[20px] xl:tw-h-[30px] tw-w-[20px] xl:tw-w-[30px] tw-object-contain" />
                <div>
                    <p className="tw-font-[600]">100% Completed</p>
                    <div className="tw-w-[100px] xl:tw-w-[200px] tw-h-[6px] tw-rounded-full tw-bg-[#7C7C7C] tw-mt-2 tw-overflow-hidden">
                        <div className={`tw-w-[${100}%] tw-h-full tw-bg-[#198038]`} />
                    </div>
                </div>
            </div>
            {!screen && (
                <>
                    <div className="tw-flex tw-items-center tw-gap-2">
                        <button className="tw-bg-secondary hover:tw-bg-secondary_hover tw-text-white tw-rounded-md tw-px-2 xl:tw-px-5 tw-py-1">
                            SAVE
                        </button>
                        <button className="tw-bg-[#7C7C7C] tw-text-white tw-rounded-md tw-px-2 xl:tw-px-5 tw-py-1">Exit</button>
                    </div>
                    <div className="tw-flex tw-items-center tw-gap-2">
                        <button
                            onClick={onPrev}
                            className="tw-bg-[#fff] tw-text-[#001659] tw-border tw-border-[#001659] tw-rounded-md tw-px-2 xl:tw-px-5 tw-py-1"
                        >
                            Prev
                        </button>
                        <button
                            // onClick={onNext}
                            type="submit"
                            className="tw-bg-[#fff] tw-text-[#001659] tw-border tw-border-[#001659] tw-rounded-md tw-px-2 xl:tw-px-5 tw-py-1"
                        >
                            Next
                        </button>
                    </div>
                </>
            )}
            {screen === "preview" && (
                <div className="tw-flex tw-items-center tw-gap-1 xl:tw-gap-5">
                    <button
                        onClick={() => navigate("/contract-generation/questionaire/")}
                        className="tw-bg-[#001659] tw-text-[14px] xl:tw-text-[18px] tw-rounded-md  tw-px-3 tw-py-1 tw-text-white"
                    >
                        Go Back to Questionnaire
                    </button>
                    <button
                        onClick={() => navigate("/contract-generation/final-review/")}
                        className="tw-bg-[#12B76A] tw-text-[14px] xl:tw-text-[18px] tw-rounded-md  tw-px-3 tw-py-1 tw-text-white"
                    >
                        Final Review
                    </button>
                </div>
            )}
            {screen === "final-preview" && (
                <div className="tw-flex tw-items-center tw-gap-1 xl:tw-gap-5">
                    <button
                        onClick={() => navigate("/contract-generation/questionaire/")}
                        className="tw-bg-[#001659] tw-text-[14px] xl:tw-text-[18px] tw-rounded-md  tw-px-3 tw-py-1 tw-text-white"
                    >
                        Go Back to Questionnaire
                    </button>
                    <button
                        onClick={() => {}}
                        className="tw-bg-[#12B76A] tw-text-[14px] xl:tw-text-[18px] tw-rounded-md  tw-px-3 tw-py-1 tw-text-white"
                    >
                        Submit Contract
                    </button>
                </div>
            )}
        </div>
    );
}
